__turbopack_context__.v({
  "blocksBackgroundColor": "Logo-module-scss-module__k7Etcq__blocksBackgroundColor",
  "blocksFontColor": "Logo-module-scss-module__k7Etcq__blocksFontColor",
  "orgLogo": "Logo-module-scss-module__k7Etcq__orgLogo",
  "orgLogoDisabled": "Logo-module-scss-module__k7Etcq__orgLogoDisabled",
  "orgLogoUpload": "Logo-module-scss-module__k7Etcq__orgLogoUpload",
  "orgLogoUploadLoading": "Logo-module-scss-module__k7Etcq__orgLogoUploadLoading",
  "secondaryNavBackgroundColor": "Logo-module-scss-module__k7Etcq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Logo-module-scss-module__k7Etcq__themeBackgroundColor",
  "themeFontColor": "Logo-module-scss-module__k7Etcq__themeFontColor",
  "themeFontFamily": "Logo-module-scss-module__k7Etcq__themeFontFamily",
  "uploadContainer": "Logo-module-scss-module__k7Etcq__uploadContainer",
});
